const PAGE = {
  HOME: ``,
  INVOICESlIST: `/list`,
  DETAIL: `/detail`,
};

export default PAGE;
